export const products = [
    {
        "title": "Medicine",
        "price": "400",
        "image": "https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2030&q=80"
    },
    {
        "title": "Masks 10-Pack",
        "price": "200",
        "image": "https://images.unsplash.com/photo-1597926576374-c24046ef7cf5?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80"
    },
    {
        "title": "50 Litre Water",
        "price": "500",
        "image": "https://images.unsplash.com/photo-1536939459926-301728717817?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80"
    },
    {
        "title": "Canned Beans",
        "price": "60",
        "image": "https://images.unsplash.com/photo-1584263347416-85a696b4eda7?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80"
    },
    {
        "title": "Phone",
        "price": "4000",
        "image": "https://images.unsplash.com/photo-1606044032786-9201c55b80a0?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80"
    },
    {
        "title": "Cleaning Solution",
        "price": "80",
        "image": "https://images.unsplash.com/photo-1584813470613-5b1c1cad3d69?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80"
    },
    {
        "title": "100 Paper Bags",
        "price": "50",
        "image": "https://images.unsplash.com/photo-1607083205410-7e6835ffd235?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80"
    },
    {
        "title": "50 Tissues",
        "price": "100",
        "image": "https://images.unsplash.com/photo-1609840112990-4265448268d1?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2100&q=80"
    }
]
